import { gql } from '@apollo/client'
import React from 'react'

import { compliancesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import { usePlacesAvailability } from './PlacesAvailabilityLoader'

const Context = React.createContext({})
const { Provider } = Context

// Keyed by place id -> openNonCompliancesCount. `places` doesn't carry this count
// itself (it lives in the compliances microservice), so it's fetched separately for
// the currently loaded page of places and merged in here.
export const useOpenNonCompliancesCountByPlaceId = () => React.useContext(Context)

const QUERY = gql`
  query AvailabilityOpenNonCompliancesCounts($filter: PlaceNonComplianceFilter) {
    placeNonCompliances(filter: $filter) {
      place {
        id
      }
      openNonCompliancesCount
    }
  }
`

const OpenNonCompliancesCountsLoader = ({ children }) => {
  const places = usePlacesAvailability()
  const placeIds = places.map(place => place.id)

  const { data } = useQuery(QUERY, {
    variables: { filter: { placeIds } },
    client: compliancesClient,
    skip: !placeIds.length,
    fetchPolicy: 'cache-and-network'
  })

  const countByPlaceId = (data?.placeNonCompliances || []).reduce((acc, item) => {
    acc[item.place.id] = item.openNonCompliancesCount
    return acc
  }, {})

  return <Provider value={countByPlaceId}>{children}</Provider>
}

export default OpenNonCompliancesCountsLoader
